import { DashboardRequestStatus } from '../enum/dashboard-request-status';


export class DashboardRequestResult {
  public status!: DashboardRequestStatus;
  public data: any;
}
